import {CommonRootState} from '../types';

export const selectFeatureFlag = (state: CommonRootState, flag: string) =>
  state.featureFlags?.flags?.[flag] ?? false;

export const selectAqForecastEnabled = (state: CommonRootState) =>
  state.featureFlags?.flags?.['aq_forecast'] ?? false;

export const selectStripeConfig = (state: CommonRootState) =>
  state.featureFlags?.stripeConfig ?? null;
